import { createGlobalStyle } from 'styled-components'
import { resets, scaffolding } from 'theme/default'

export const GlobalStyled = createGlobalStyle`
  ${resets}
  ${scaffolding}
`
